//#region src/function/identity.ts
function identity(value) {
	return value;
}
//#endregion
export { identity };

//# sourceMappingURL=identity.js.map